module.exports = __webpack_public_path__ + "static/media/mus-logo-horizen.858614e7.svg";